export { store } from './store';

export {
  goToRoute,
  setMinimizedView,
  closeSideBar,
  openSideBar,
} from './actions';



// WEBPACK FOOTER //
// ./application/index.js